import { ACTIONS } from './types';

export const setPathsActionCreator = paths => ({
    type: ACTIONS.SET_PATHS,
    payload: paths,
});
